<template>
  <v-app>
    <v-navigation-drawer
        fixed
        :clipped="$vuetify.breakpoint.mdAndUp"
        app
        v-model="drawer"
    >
      <v-list dense>
        <template v-for="item in adminItems">
          <v-list-tile v-if="!item.children" :to="item.to" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-group
              v-else
              v-model="item.model"
              :key="'group-' + item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                :to="child.to"
                v-for="(child, i) in item.children"
                :key="i"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    
    <v-progress-linear
        v-if="this.$store.state.progress"
        color="deep-purple"
        indeterminate
        height="6"
        style="position: fixed; top: 50px; z-index: 99999"
    ></v-progress-linear>
    
    <v-toolbar
        color="red darken-2"
        app
        :clipped-left="$vuetify.breakpoint.mdAndUp"
        fixed
        dark
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon
            @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">Admin Panel - {{ currentUser.firstName }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        v-if="currentUser && currentUser.canAccessAdmin && !currentUser.isAdmin"
        flat
        class="hidden-sm-and-down"
        @click="$router.push('/')"
      >
        <v-icon left small>arrow_back</v-icon>
        Normal Ekrana Dön
      </v-btn>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn icon large @click="logout">
        <v-avatar size="32px" tile>
          <img src="@/assets/logo.svg" alt="Admin" />
        </v-avatar>
      </v-btn>
    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>
    
    <v-dialog v-model="$store.state.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Bilgilendirme</v-card-title>
        <v-card-text>{{ $store.state.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              dark
              depressed
              @click="$store.state.dialog = false"
          >Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      currentUser: null,
      drawer: null,
      selectedTenantId: parseInt(localStorage.getItem('selectedTenantId') || '0', 10) || 0,
      fullAdminItems: [
        { icon: "dashboard", text: "Dashboard", to: "/admin" },
        { icon: "people", text: "Kullanıcılar", to: "/admin/users" },
        { icon: "business", text: "Kullanıcı Tenants", to: "/admin/user-tenants" },
        { icon: "account_balance", text: "Anlaşmalı Bankalar", to: "/admin/partner-banks" },
        { icon: "savings", text: "Para & Bankalar (AF)", to: "/admin/cash-accounts" },
        { icon: "payments", text: "Para Birimleri", to: "/admin/currencies" },
        { icon: "factory", text: "Rafineriler", to: "/admin/refineries" },
        { icon: "precision_manufacturing", text: "Atölyeler", to: "/admin/atolye" },
        { icon: "local_shipping", text: "Teslimat Şehirleri", to: "/admin/delivery-cities" },
        { icon: "event_busy", text: "Banka Tatilleri", to: "/admin/bank-holidays" },
        { icon: "event_repeat", text: "Pazaryeri Para Kuralları", to: "/admin/marketplace-payment-rules" },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Şirket Yönetimi",
          model: false,
          children: [
            { icon: "business", text: "Şirketler", to: "/admin/companies" },
            { icon: "link", text: "MP Şirketleri", to: "/admin/mp-companies" }
          ]
        },
        {
          icon: "assessment",
          text: "Kampanya Komisyonları",
          to: "/admin/campaign-commissions"
        },
        { icon: "settings", text: "Uygulama Ayarları", to: "/admin/app-settings" }, 
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Ürün Yönetimi",
          model: false,
          children: [
            { icon: "list", text: "Ürün Listele", to: "/admin/product" },
            { icon: "add", text: "Ürün Ekle", to: "/admin/product/detail" }
          ]
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "İndirim Yönetimi",
          model: false,
          children: [
            { icon: "list", text: "İndirim Listele", to: "/admin/discount" },
            { icon: "add", text: "İndirim Ekle", to: "/admin/discount/detail" }
          ]
        },
        {
          icon: "assessment",
          text: "Kampanya Komisyonları",
          to: "/admin/campaign-commissions"
        },
        {
          icon: "payment",
          text: "Beklenen Ödeme Kalemleri",
          to: "/admin/expected-payments"
        },
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Envanter Yönetimi",
          model: false,
          children: [
            { icon: "inventory_2", text: "Envanter Listesi", to: "/admin/inventory" },
            { icon: "diamond", text: "Takı Envanter", to: "/admin/inventory/jewelry" },
            { icon: "assignment_ind", text: "Zimmet", to: "/admin/inventory/zimmet" },
            { icon: "account_balance", text: "Kasa", to: "/admin/inventory/kasa" },
            { icon: "category", text: "Diğer Zimmet Kalemleri", to: "/admin/inventory/other-items" },
            { icon: "tune", text: "Tanımlar", to: "/admin/inventory/definitions" },
            { icon: "call_made", text: "Borç", to: "/admin/inventory/borc" },
            { icon: "point_of_sale", text: "Diğer Satışlar", to: "/admin/inventory/other-sales" },
            { icon: "warning", text: "Kritik Stok Takibi", to: "/admin/inventory/kritik-stok" },
            { icon: "history", text: "Mutabakat Geçmişi", to: "/admin/mutabakat-gecmisi" },
          ]
        },
        { icon: "account_balance_wallet", text: "Kasam", to: "/kasam" },
        {icon: "keyboard_arrow_up","icon-alt": "keyboard_arrow_down", model: false, text: "Idia Web",
        children: [
          { icon: "inventory_2", text: "Ürün Listele", to: "/admin/product" },
          { icon: "category", text: "Kategori Yönetimi", to: "/admin/categories" },
          { icon: "view_carousel", text: "Carousel Yönetimi", to: "/admin/carousels" },
          { icon: "star", text: "Çok Satanlar", to: "/admin/bestsellers" },
          { icon: "account_tree", text: "Varyant Yönetimi", to: "/admin/variants" },
          { icon: "article", text: "Blog Yönetimi", to: "/admin/blog" }
            ]},

      ],
      adminWebItems: [
        {icon: "keyboard_arrow_up","icon-alt": "keyboard_arrow_down", model: true, text: "Idia Web",
        children: [
          { icon: "inventory_2", text: "Ürün Listele", to: "/admin/product" },
          { icon: "category", text: "Kategori Yönetimi", to: "/admin/categories" },
          { icon: "view_carousel", text: "Carousel Yönetimi", to: "/admin/carousels" },
          { icon: "star", text: "Çok Satanlar", to: "/admin/bestsellers" },
          { icon: "account_tree", text: "Varyant Yönetimi", to: "/admin/variants" },
          { icon: "article", text: "Blog Yönetimi", to: "/admin/blog" }
            ]},
      ],
      envanterAdminItems: [
        {
          icon: "keyboard_arrow_up",
          "icon-alt": "keyboard_arrow_down",
          text: "Envanter Yönetimi",
          model: true,
          children: [
            { icon: "inventory_2", text: "Envanter Listesi", to: "/admin/inventory" },
            { icon: "diamond", text: "Takı Envanter", to: "/admin/inventory/jewelry" },
            { icon: "assignment_ind", text: "Zimmet", to: "/admin/inventory/zimmet" },
            { icon: "account_balance", text: "Kasa", to: "/admin/inventory/kasa" },
            { icon: "category", text: "Diğer Zimmet Kalemleri", to: "/admin/inventory/other-items" },
            { icon: "tune", text: "Tanımlar", to: "/admin/inventory/definitions" },
            { icon: "call_made", text: "Borç", to: "/admin/inventory/borc" },
            { icon: "point_of_sale", text: "Diğer Satışlar", to: "/admin/inventory/other-sales" },
            { icon: "warning", text: "Kritik Stok Takibi", to: "/admin/inventory/kritik-stok" },
            { icon: "history", text: "Mutabakat Geçmişi", to: "/admin/mutabakat-gecmisi" },
          ]
        },
        { icon: "account_balance_wallet", text: "Kasam", to: "/kasam" },
      ]
    };
  },
  computed: {
    adminItems() {
      let items;
      if (this.currentUser && this.currentUser.isEnvanterAdmin) {
        items = this.envanterAdminItems;
      } else if (this.currentUser && this.currentUser.isAdminWeb) {
        items = this.adminWebItems;
      } else {
        items = this.fullAdminItems;
      }
      if (this.currentUser && this.currentUser.canManageLeaves) {
        items = [...items, { icon: "event_busy", text: "İzin Yönetimi", to: "/admin/leaves" }];
      }
      const tenant = this.selectedTenantId
        || (this.currentUser && this.currentUser.tenantId)
        || 0;
      return items.filter(item => !item.tenantOnly || item.tenantOnly === tenant);
    }
  },
  created() {
    authenticationService.currentUser.subscribe(
        (x) => {
          this.currentUser = x || {};
        }
    );
  },
  methods: {
    logout() {
      authenticationService.logout();
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
/* Admin paneli için özel stiller */
.v-toolbar {
  background: linear-gradient(45deg, #c62828, #d32f2f) !important;
}

</style>
